export default {
  title: 'Maksa PayPalilla',
  error: 'PayPal-maksua ei voitu suorittaa loppuun. Yritä uudelleen.',
};
